export const API_URL = `${window.location.origin}`